import React, { forwardRef } from "react";

export const WrapperTable = forwardRef(
  (props: any, ref: React.ForwardedRef<HTMLDivElement>) => {
    return (
      <>
        <div
          id="print-content"
          style={{ height: "calc(100% - 100px)", paddingTop:4 }}
          ref={ref}
        >
          <div {...props}/>
        </div>
      </>
    );
  }
);
